import { render, staticRenderFns } from "./ItemListCurationRequestLayout.vue?vue&type=template&id=5a117458&scoped=true&"
import script from "./ItemListCurationRequestLayout.vue?vue&type=script&lang=js&"
export * from "./ItemListCurationRequestLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a117458",
  null
  
)

export default component.exports